<template>
  <div
    class="h-screen flex w-full"
    id="page-login"
  >
    <div class="mx-auto self-center" style="width: 400px">
      <Card>
        <EmployeeRegisterByInvitationForm />
      </Card>
    </div>
  </div>
</template>

<script>
import EmployeeRegisterByInvitationForm from './EmployeeRegisterByInvitationForm'
export default {
  components: {
    EmployeeRegisterByInvitationForm
  }
}
</script>
